export default __webpack_public_path__ + "static/media/center-pointe-2020-white.25ea553d.svg";